// export const BACKEND_BASE_URL = "https://testmhcdevblobapi.myhealthcare.co";         // testmhcdev
// export const BACKEND_BASE_URL = "https://ppablobapi.rfhospital.org";                 // rfh ppa
// export const BACKEND_BASE_URL = "https://blobapi.rfhospital.org";                    // rfh prod
// export const BACKEND_BASE_URL = "https://sparsh.sandboxblobapi.myhealthcare.life";   // sparsh sandbox
// export const BACKEND_BASE_URL = "https://sparsh.blobapi.myhealthcare.life";          // sparsh prod
// export const BACKEND_BASE_URL = "https://digihealth-blobapi.ckbirlahospitals.co.in"; // CKB UAT
// export const BACKEND_BASE_URL = "https://blobapi.digihealth.ckbirlahospitals.in";    // CKB prod
// export const BACKEND_BASE_URL = "https://ainu.sandbox.blobapi.myhealthcare.life";    // AINU sandbox
export const BACKEND_BASE_URL = "https://ainu.blobapi.myhealthcare.life";    // AINU prod
// export const BACKEND_BASE_URL = "http://localhost:1337";


export const GET_DOCUMENT_DEC_URL = BACKEND_BASE_URL + "/api/v1/documents/file-buffer";
export const AUTH_FILE_BUFFER_URL = BACKEND_BASE_URL + "/api/v1/documents/auth-file-buffer";
export const GET_SCODE_REDIRECT = BACKEND_BASE_URL + "/api/v1/documents/get-redirect-url";
export const GET_UUID_BASE_DATA = BACKEND_BASE_URL + "/api/v1/documents/get-uuid-data";
export const GET_OTP_URL = BACKEND_BASE_URL + "/api/v1/documents/send-otp";
export const VERIFY_OTP_URL = BACKEND_BASE_URL + "/api/v1/documents/verify-otp";

export const API_STATIC_TOKEN = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoiTXIuQWsiLCJ1c2VyVHlwZSI6Im5lc3QiLCJpYXQiOjE1MTYyMzkwMjIsImlzcyI6Imh0dHBzOi8vdGVzdG1oY2RldmJsb2JhcGkubXloZWFsdGhjYXJlLmNvIn0.UwbCaPDfVumJJkSYp9P4H3YAisUdV7AJeaKPgIsUoAQ";

export const INVALID_MESSAGE = "Invalid document link!";

export const LOADER = (
    <div className="spinner">
        <div className="bounce1"></div>
        <div className="bounce2"></div>
        <div className="bounce3"></div>
    </div>
);
export const LOADER_RED = (
    <div className="spinner red">
        <div className="bounce1"></div>
        <div className="bounce2"></div>
        <div className="bounce3"></div>
    </div>
);
export const LOADER_BLACK = (
    <div className="spinner black">
        <div className="bounce1"></div>
        <div className="bounce2"></div>
        <div className="bounce3"></div>
    </div>
);